export const FALLBACK_CATEGORY = "أخرى (تحديد)";

export const DEFAULT_CATEGORIES = [
  "الوقود والمحروقات",
  "الصيانة وقطع الغيار",
  "مستلزمات النظافة والمعطرات",
  "الاتصالات والإنترنت",
  "المستلزمات المكتبية",
  "الأجهزة والمعدات",
  "مصروفات البوفية",
  "التنقلات والمواصلات",
  "الإيجارات والخدمات",
  "مصروفات طارئة",
  "صرف صحي",
  "عامل نظافة المحطة",
  FALLBACK_CATEGORY,
];

const PALETTE = [
  "#2B4A73", "#6E6657", "#1E6F7D", "#5B3E82", "#5C7D28", "#1F3A33",
  "#C97B2D", "#2F6660", "#B04A75", "#C84C31", "#3F6B2F", "#C9A227",
  "#8A5A3B", "#4A5568", "#7A5B16", "#933A5E", "#2D6A4F", "#7D3C98",
];
const FALLBACK_HEX = "#8A8D86";

// Module-level active list — set by useCategories() after fetching the user's custom list.
let ACTIVE = DEFAULT_CATEGORIES;
export const setActiveCategories = (list) => {
  if (Array.isArray(list) && list.length) ACTIVE = list;
};
export const getActiveCategories = () => ACTIVE;

export const categoryLabel = (cat) => (ACTIVE.includes(cat) ? cat : FALLBACK_CATEGORY);

export const categoryHex = (cat) => {
  if (!cat || cat === FALLBACK_CATEGORY || !ACTIVE.includes(cat)) return FALLBACK_HEX;
  return PALETTE[ACTIVE.indexOf(cat) % PALETTE.length];
};

// Inline style for badges (dynamic categories can't use static tailwind classes)
export const categoryBadgeStyle = (cat) => {
  const hex = categoryHex(cat);
  return { backgroundColor: `${hex}1C`, color: hex };
};
